var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.605469,
    y: 0.282227,
    width: 34.4521,
    height: 26.3457,
    rx: 4.01296,
    fill: "url(#paint0_linear_2725_3697)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5117 7.82886L23.9349 7.92916L23.8432 18.9399L11.42 18.8396L11.5117 7.82886ZM12.0676 8.39393L11.9852 18.2835L23.2873 18.3748L23.3697 8.48519L12.0676 8.39393Z",
    fill: "#253A53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4785 3.90039L29.4082 3.99671L29.3704 8.53396L17.4407 8.43764L17.4785 3.90039ZM18.0344 4.46546L18.0059 7.88162L28.8145 7.96888L28.843 4.55273L18.0344 4.46546Z",
    fill: "#253A53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10547 3.80835L18.0351 3.90467L17.9973 8.44192L6.06765 8.3456L6.10547 3.80835ZM6.66135 4.37342L6.63287 7.78957L17.4414 7.87684L17.4699 4.46069L6.66135 4.37342Z",
    fill: "#253A53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3574 18.3318L29.2871 18.4281L29.2493 22.9654L17.3196 22.869L17.3574 18.3318ZM17.9133 18.8969L17.8848 22.313L28.6934 22.4003L28.7219 18.9841L17.9133 18.8969Z",
    fill: "#253A53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98438 18.2456L17.914 18.3419L17.8762 22.8792L5.94656 22.7829L5.98438 18.2456ZM6.54025 18.8107L6.51178 22.2269L17.3203 22.3141L17.3488 18.8979L6.54025 18.8107Z",
    fill: "#253A53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9312 8.58013L29.123 8.5293L29.128 7.96875L34.9361 8.01959L34.9312 8.58013Z",
    fill: "#253A53"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8453 19.0309L29.0371 18.9857L29.0415 18.4251L34.8496 18.4703L34.8453 19.0309Z",
    fill: "#253A53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63615 8.3489L0.822266 8.30371L0.826622 7.74316L6.6405 7.78835L6.63615 8.3489Z",
    fill: "#253A53"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55021 18.8049L0.736328 18.7541L0.74123 18.1935L6.55511 18.2444L6.55021 18.8049Z",
    fill: "#253A53"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7777 13.6193L0.78125 13.5289L0.785857 12.9683L11.7823 13.0587L11.7777 13.6193Z",
    fill: "#253A53"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8914 13.8057L23.6367 13.7153L23.6412 13.1548L34.8959 13.2452L34.8914 13.8057Z",
    fill: "#253A53"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95117 26.3069L5.97987 22.4939L6.54042 22.4981L6.51172 26.3111L5.95117 26.3069Z",
    fill: "#253A53"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3203 26.3965L17.3547 22.5835L17.9153 22.5886L17.8809 26.4016L17.3203 26.3965Z",
    fill: "#253A53"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6895 26.4873L28.7239 22.6799L29.2844 22.685L29.25 26.4924L28.6895 26.4873Z",
    fill: "#253A53"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6328 26.5324L11.6672 22.5386L12.2278 22.5434L12.1934 26.5372L11.6328 26.5324Z",
    fill: "#253A53"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 26.6286L23.2844 22.6348L23.845 22.6396L23.8105 26.6334L23.25 26.6286Z",
    fill: "#253A53"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13477 4.08961L6.16346 0.282227L6.72401 0.286451L6.69532 4.09383L6.13477 4.08961Z",
    fill: "#253A53"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5039 4.17969L17.5383 0.372314L18.0989 0.377384L18.0645 4.18476L17.5039 4.17969Z",
    fill: "#253A53"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.875 4.27003L28.9094 0.462646L29.47 0.467716L29.4355 4.2751L28.875 4.27003Z",
    fill: "#253A53"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8164 4.32094L11.8508 0.327148L12.4114 0.331982L12.377 4.32578L11.8164 4.32094Z",
    fill: "#253A53"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4336 4.41128L23.468 0.41748L24.0286 0.422314L23.9941 4.41611L23.4336 4.41128Z",
    fill: "#253A53"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2725_3697",
    x1: 0.605469,
    y1: 1.29552,
    x2: 33.031,
    y2: 26.6279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.e1dd55702cf49cfbdf1234b953aa666c.svg";
export { ForwardRef as ReactComponent };